/* Aitomatto: global percentage-discount sort of filtered collections, opt-in. */
(function(){
 var active=function(){return new URLSearchParams(location.search).get('ait_discount')==='1';};
 var selected=new WeakSet();
 var name={fi:'Suurin alennus',en:'Biggest discount',sv:'Största rabatten'}[document.documentElement.lang.split('-')[0]]||'Suurin alennus';
 var listSelector='#ResultsList ul.product-grid';
 var cards=function(root){return Array.from(root.querySelectorAll(listSelector+' > li.product-grid__item'));};
 document.addEventListener('click',function(event){
   var link=event.target.closest&&event.target.closest('.ait-discount-sort-link');
   if(!link)return;
   event.preventDefault();
   var url=new URL(location.href);
   url.searchParams.delete('page');url.searchParams.delete('sort_by');
   url.searchParams.set('ait_discount','1');
   location.assign(url.href);
 });
 function labels(){
   if(!active())return;
   document.querySelectorAll('.ait-discount-sort-link').forEach(function(link){
     link.classList.add('is-active');link.setAttribute('aria-current','true');
     var tick=link.querySelector('.ait-discount-tick');if(tick && tick.textContent!=='✓')tick.textContent='✓';
   });
   document.querySelectorAll('.ait-desktop-sort-summary > span:first-child, .ait-mobile-sort-summary > span:first-child').forEach(function(e){if(e.textContent!==name)e.textContent=name;});
 }
 async function load(list){
   if(selected.has(list))return;selected.add(list);
   var owner=list.closest('#ResultsList');var pager=owner&&owner.querySelector('.ait-load-more');
   if(!pager)return;
   var initial=cards(owner);var all=initial.slice();
   var pages=Number(list.dataset.lastPage)||1;
   var total=Number(pager.dataset.total)||initial.length;
   var info=document.createElement('p');info.className='ait-discount-loading';info.setAttribute('role','status');
   info.textContent='Järjestetään alennuksia...';
   list.parentElement.insertBefore(info,list);pager.style.display='none';
   try{
     var next=2;
     async function worker(){
       while(next<=pages){
         var index=next++;var url=new URL(location.href);
         url.searchParams.delete('ait_discount');url.searchParams.set('page',String(index));
         var response=await fetch(url.href,{credentials:'same-origin'});
         if(!response.ok)throw Error('HTTP '+response.status);
         var doc=new DOMParser().parseFromString(await response.text(),'text/html');
         var more=cards(doc);
         if(!more.length&&index<pages)throw Error('Tuotteita ei löytynyt');
         all.push.apply(all,more);
         info.textContent='Järjestetään alennuksia... '+Math.min(index,pages)+' / '+pages;
       }
     }
     await Promise.all(Array.from({length:Math.min(4,Math.max(0,pages-1))},worker));
     if(!list.isConnected||!active())return;
     all.sort(function(a,b){return (Number(b.dataset.aitDiscount)||0)-(Number(a.dataset.aitDiscount)||0);});
     initial.forEach(function(x){x.remove();});
     var shown=Math.min(24,all.length);
     var frag=document.createDocumentFragment();
     all.slice(0,shown).forEach(function(x){frag.appendChild(x);});list.appendChild(frag);
     var counter=pager.querySelector('[data-ait-loaded]');
     var progress=pager.querySelector('.ait-load-more__progress');
     var track=pager.querySelector('.ait-load-more__track');
     var button=pager.querySelector('.ait-load-more__button');
     if(!button&&shown<all.length){
       button=document.createElement('button');button.type='button';button.className='ait-load-more__button';
       button.textContent='Lataa lisää';pager.appendChild(button);
     }
     function update(){
       if(counter)counter.textContent=String(shown);
       if(progress)progress.style.width=(total?Math.min(100,shown/total*100):100)+'%';
       if(track)track.setAttribute('aria-valuenow',String(shown));
       if(button)button.hidden=shown>=all.length;
     }
     if(button)button.addEventListener('click',function(){
       var fragment=document.createDocumentFragment();
       all.slice(shown,shown+24).forEach(function(e){fragment.appendChild(e);});
       list.appendChild(fragment);shown=Math.min(shown+24,all.length);update();
     });
     update();pager.style.display='';pager.classList.add('ait-ready');info.remove();
   }catch(err){
     console.error('Aitomatto: suurin alennus',err);
     info.textContent='Alennusjärjestystä ei voitu ladata. ';
     var retry=document.createElement('a');retry.href=location.href;retry.textContent='Yritä uudelleen';info.appendChild(retry);
     pager.style.display='';
   }
 }
 function init(){labels();if(!active())return;var list=document.querySelector(listSelector);if(list&&!selected.has(list))load(list);}
 function start(){init();new MutationObserver(init).observe(document.body,{childList:true,subtree:true});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();